export default __webpack_public_path__ + "static/media/sron-logo.6a988fe5.png";